import { useMemo } from "react";
import type { Location, NavigateFunction } from "react-router-dom";
import useIsMobile from "../../../../hooks/device/useIsMobile";
import Header from "../../../components/Header";
import { HeaderFixedOnTop } from "../../../components/Header/HeaderFixedOnTop";
import { HeaderModalBar } from "../../../components/HeaderModalBar/header-modal-bar.component";

export interface SignDocumentHeaderProps {
  navigate?: NavigateFunction;
  location?: Location;
}

const EMPTY_STRING = "";

export function SignDocumentHeader({ navigate, location }: SignDocumentHeaderProps): JSX.Element {
  const isMobile = useIsMobile();

  const header = useMemo(
    function getHeader() {
      let header = <HeaderModalBar title="Firma documento" />;

      if (isMobile && location) {
        const fromPath = (location.state as { from?: string })?.from;
        header = (
          <HeaderFixedOnTop>
            <Header
              options={{
                title: EMPTY_STRING,
                backButton: { url: fromPath ?? EMPTY_STRING },
                visibleActions: [],
              }}
            />
          </HeaderFixedOnTop>
        );
      }

      return header;
    },
    [isMobile, location]
  );

  return header;
}
